export const oneClickEnabledProjects = [
  '7b001559-12ea-4042-ab43-55e2d63e9d54',
  '651857df-0c72-4bdb-8613-09324c639cb3', // Imaad Local test
  '3605ee97-ca9b-4896-b0d6-fbdb0d8c7111', // Prod Test Project
  '1cf76830-40d4-4152-b558-1d6e509c03a9', // Demo UK - 1 Main Street (1st)
  '5ad24dfb-85d8-45ab-a12e-29b820d8e796', // Demo UK - 1 Main Street (2nd)
  '46f159fe-844f-4e79-88bf-18b11ee0be1b', // Demo US - Demo Main Project
  'c3a4c204-3af6-4fb9-8aa7-effa6a4cb3e5', // Dev - UAT Account - UAT Project 1
  '4cebaa8b-2377-4a83-a53a-665b5efc339d', // System-Tests - Delivery Reports Seed Data - 'Reports-Project'
  'dcbfa047-5646-4936-bf1d-217a2a469562', // Skyscanner Limited- Blackwater client project
  'a3924660-f54b-4187-86e3-b8d6f674af18', // Orms Account Project
  'f42e315a-2a98-4d72-ab36-d6337ba7328b', // Berkeley Capital - BCET - KV3/6
  'dc905806-04d6-40c9-b808-701f61b62ba6', // Berkeley Oxford and Chiltern - Winterbrook Wallingford
  '4f693196-6e23-4d02-996d-38ede95bdf37', // Berkeley St Edward - Oval Village
  'df794b49-f38d-4bc6-aebc-2df5e9235869', // Howard de Walden Estate -	10 John Princes St
  'a992b059-9181-4a42-a11a-ac066b04f2d7', // Howard de Walden Estate -	19 Portland Place-Refurb
  'e726589e-496d-41b2-a195-298f36ee653a', // Howard de Walden Estate -	28 Park Crescent Mews West
  '5485bcd4-6d7b-4b32-8b7f-d7d78481d2fa', // Howard de Walden Estate -	32 Welbeck Street
  '540cdce4-9e04-4606-b589-3c133e898dc9', // Howard de Walden Estate -	36-37 Welbeck St
  'cb787a53-1637-476a-b37e-77426363dda7', // Howard de Walden Estate -	60 Harley Street
  '6a1025cf-3180-41ac-aa35-114d3ab438fa', // Howard de Walden Estate -	7 Bentinck St & 2+3 Bentinck Mews
  'be794927-27dd-42a4-b2eb-8aa7bbe9490e', // Howard de Walden Estate -	76-78 Portland Place
  'b964f128-cd17-4a55-aa02-c70803097a5f', // Howard de Walden Estate -	79 Wimpole Street (Medical Refurbishment)
  'f1b47e82-1590-45e5-898a-8c876193540a', // Howard de Walden Estate -	9 Wimpole Street
  '28d68125-a583-44ce-829b-0591e943f7e4', // Howard de Walden Estate -	97-100 Marylebone High St
  '84020aaa-50c9-48da-96d7-db214527bff2', // Howard de Walden Estate -	Flat 2, 103 Marylebone High Street
  'eb8cb5ef-3ea9-4b9d-b595-34a136e65b89', // SMT - 14 North Row
  '8ab723e5-fe19-41d5-bfd7-802fc6f923fd', // SMT - North & South Blocks - McGee
  '4dc1a604-5225-4727-b0cd-4cd89b9c458c', // SMT - South Molton Street - Curo Construction
  'b8413a50-21ff-4a6a-a63a-615d2930c29e', // SMT - South Molton Street - Red Construction
  '135c7d63-e230-4911-96b2-9146c331d7de', // St Joseph - SJO - Highcroft
  'adad441d-16e9-4db3-bcef-3348bc19abdb', // Workplace Futures Group - 160 QVS - 3074A
  '79cd3920-1696-4cd3-8e81-1ad11f62224f' // Workplace Futures Group - Finsbury Circus House
]

export const createFilterDescription = filters => {
  if (filters) {
    const filterStringArray: string[] = []
    if (filters.assignedTo && filters.assignedTo.length > 0) {
      filterStringArray.push('Assigned To')
    }
    if (filters.deliveryAddress && filters.deliveryAddress.length > 0) {
      filterStringArray.push('Delivery Address')
    }
    if (filters.deliveryId && filters.deliveryId.length > 0) {
      filterStringArray.push('Delivery ID')
    }
    if (filters.knownSupplierName && filters.knownSupplierName.length > 0) {
      filterStringArray.push('Supplier Company')
    }
    if (filters.tradeContractor && filters.tradeContractor.length > 0) {
      filterStringArray.push('Trade Contractor')
    }

    if (filterStringArray.length > 0) {
      return filterStringArray.join(', ')
    }
  }

  return ''
}
